import { Wrapper } from 'components/types'
import { classNames } from 'utils/dom-helpers'

export function ModalWrapper({
    children,
    className,
    style,
    zIndex,
    rootClassName,
}: Wrapper) {
    return (
        <div
            className={classNames(
                'fixed inset-0 bg-gray-800 bg-opacity-70 flex items-center overflow-x-hidden',
                zIndex && zIndex.length > 0 ? zIndex : 'z-[101]',
                rootClassName || ""
            )}
        >
            <div
                style={style && style}
                className={classNames(
                    className || '',
                    'xl:w-wider w-[80%] m-auto h-auto lg:h-screen flex flex-col'
                )}
            >
                {children}
            </div>
        </div>
    )
}
